module.exports = __webpack_public_path__ + "img/filterbanner.5422db50.png";